<template>
  <div>
    <!-- Botones -->
    <div style="margin-bottom: 16px; display: flex;">
      <b-button class="ml-1" @click="exportLots" style="display: flex; flex-direction: row; align-items: center;">
        <i class='p-0 fa fa-download' style="margin-right: 8px;"></i> Exportar a XLS
      </b-button>
      <b-button class="ml-1" @click="confirmCloseAllLots"
                style="display: flex; flex-direction: column; align-items: center;">
        <i style="margin-right: 8px;"></i> Cerrar todos
      </b-button>
    </div>
    <div style="margin-bottom: 16px; display: flex;">

    </div>

    <!-- Listado de lotes -->
    <v-server-table
      v-if="!loading"
      ref="closed-lots-table"
      url="lista-lotes/"
      class="table-hide-nativetoggler"
      :columns="columns"
      :options="options">

      <div slot="create_date" slot-scope="props">
        <span> {{ props.row.create_date | formatDate }}</span>
      </div>
      <div slot="fecha_inicio_prevista" slot-scope="props">
        <span> {{ props.row.fecha_inicio_prevista | formatDate }}</span>
      </div>
      <div slot="fecha_cierre_prevista" slot-scope="props">
        <span> {{ props.row.fecha_cierre_prevista | formatDate }}</span>
      </div>
      <div slot="fecha_inicio_real" slot-scope="props">
        <span> {{ props.row.fecha_inicio_real | formatDate }}</span>
      </div>

      <div slot="actions" slot-scope="props">
        <ActionsCierreLotes :data="props.row" :index="props.index"></ActionsCierreLotes>
      </div>
      <template v-if="options.details" slot="child_row" slot-scope="props" uniqueKey="id"></template>
    </v-server-table>
    <b-modal ref="modalPreventCerrarTodosLote" @ok="closeLots">
      ¿Desea cerrar todos los lotes?
    </b-modal>
    <b-modal ref="modalPreventCerrarLote" @ok="closeLot">
      ¿Desea cerrar el lote {{ selectedLot.id }}, con la descripción '{{ selectedLot.descripcion }}'?
    </b-modal>
  </div>

</template>

<style>

.table thead th {
  position: sticky;
  top: 0;
}

tr.tr-closed-lots-table td {
  padding-bottom: 4px !important;
  padding-top: 4px !important;
  vertical-align: middle;
}

.table-responsive {
  padding-bottom: 0 !important;
  overflow-y: auto;
  max-height: 69vh;
}

</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
import Table from '@/components/Modules/Table/Table.vue';
import ActionsCierreLotes from './ActionsCierreLotes.vue';
import EventBus from '../../../../Modules/EventBus';
import moment from 'moment';
import * as FileSaver from 'file-saver';

export default {
  name: 'CierreLotesList',
  props: ['id_lote', 'permisos'],
  components: {Loader, Table, ActionsCierreLotes},
  data () {
    return {
      columns: ['id', 'tipo_lote', 'descripcion', 'usuario_asignador', 'usuario_asignado', 'status', 'create_date',
        'fecha_inicio_prevista', 'fecha_cierre_prevista', 'fecha_inicio_real', 'actions'],
      options: {
        rowClassCallback: () => {
          return 'tr-closed-lots-table';
        },
        draggable: false,
        filterByColumn: true,
        filterable: ['id', 'tipo_lote', 'descripcion', 'usuario_asignador', 'usuario_asignado',
          'status', 'create_date', 'fecha_inicio_prevista', 'fecha_cierre_prevista', 'fecha_inicio_real'],
        sortable: ['id', 'tipo_lote', 'descripcion', 'usuario_asignador', 'usuario_asignado',
          'status', 'create_date', 'fecha_inicio_prevista', 'fecha_cierre_prevista', 'fecha_inicio_real'],
        dateColumns: ['create_date', 'fecha_inicio_prevista', 'fecha_cierre_prevista', 'fecha_inicio_real'],
        dateFormat: 'YYYY/MM/DD',
        perPage: 15,
        perPageValues: [],
        row: {},
        pagination: {
          chunk: 10,
          dropdown: false
        },
        params: {
          'paginated': true
        },
        orderBy: {
          ascending: false
        },
        requestKeys: {
          query: 'search',
          orderBy: 'ordering',
          limit: 'page_size'
        },
        skin: 'table-hover',
        sortIcon: {
          base: 'fa',
          up: 'fa-caret-down',
          down: 'fa-caret-up',
          is: 'fa-sort'
        },
        datepickerOptions: {
          showDropdowns: true
        },
        headings: {
          id_lote: 'Código Lote',
          tipo_lote: 'Tipo Lote',
          descripcion: 'Descripción',
          usuario_asignador: 'Usu. Asignador',
          usuario_asignado: 'Usu. Asignado',
          status: 'Estado',
          create_date: 'Fecha Creación',
          fecha_inicio_prevista: 'Fecha Inicio Prevista',
          fecha_cierre_prevista: 'Fecha Cierre Prevista',
          fecha_inicio_real: 'Fecha Inicio Real',
          actions: 'Acciones'
        },
        requestFunction: function (data) {
          this.loading = true;
          let params = Object.keys(data.search);

          // for each column in the table
          for (let index = 0; index < params.length; index++) {
            const element = params[index];

            // Filtros de la tabla
            let val = data.search[element];
            if (val) {
              if (element.includes('fecha') || element.includes('date')) {
                data[element + '__date__gte'] = val.start;
                data[element + '__date__lte'] = val.end;
              } else {
                data[element + '__icontains'] = val.trim();
              }
            }
          }

          // Eliminamos los atributos "search" y "byColumn" para no pasarlos como parametros
          delete data.search;
          delete data.byColumn;

          // Realizamos la petición
          return this.$http.get(this.url, {params: data}).then(function (data) {
            this.loading = false;
            return data.json();
          }, function (e) {
            this.loading = false;
            this.dispatch('error', e);
            EventBus.$emit('show-error-alert', 'Error al recuperar el listado de usuarios');
          }.bind(this));
        },
        responseAdapter: function (resp) {
          return {
            data: (resp) ? resp.results : [],
            count: (resp) ? resp.count : 0
          };
        }
      },
      modalTitle: 'Cierre Lotes',
      loading: false,
      downloading: false,
      selectedLot: {}
    };
  },
  computed: {},
  mounted () {
    EventBus.$on('close-lot', this.confirmCloseLot);
  },
  beforeDestroy () {
    EventBus.$off('close-lot', this.confirmCloseLot);
  },
  filters: {
    formatDate: function (date) {
      return (date) ? moment(date).format('DD/MM/YYYY') : '';
    }
  },
  methods: {
    refreshTable: function () {
      this.$refs['closed-lots-table'].refresh();
    },
    getFilterColumns: function () {
      return this.$refs['closed-lots-table'].query;
    },
    getOrderByColumn: function () {
      return this.$refs['closed-lots-table'].orderBy;
    },
    confirmCloseAllLots: function () {
      this.$refs.modalPreventCerrarTodosLote.show();
    },
    confirmCloseLot: function (lot) {
      this.selectedLot = lot;
      this.$refs.modalPreventCerrarLote.show();
    },
    exportLots: function () {
      const filterColumns = this.getFilterColumns();
      const orderByColumn = this.getOrderByColumn();

      let params = Object.keys(filterColumns);

      // Aplicamos los sufijos de django según el tipo de campo
      const filters = {};
      for (let index = 0; index < params.length; index++) {
        const element = params[index];

        let val = filterColumns[element];
        if (val) {
          if (element.includes('fecha') || element.includes('date')) {
            filters[element + '__date__gte'] = val.start;
            filters[element + '__date__lte'] = val.end;
          } else {
            filters[element + '__icontains'] = val.trim();
          }
        }
      }

      // Query parameters and options
      let orderBy = (orderByColumn.column) ? orderByColumn.column : null;
      orderBy = (orderByColumn.ascending) ? '-' + orderBy : orderBy;
      const queryConfig = {filters: filters, orderBy: orderBy};
      const options = {responseType: 'blob'};

      // Realizamos la petición
      this.downloading = true;
      return this.$http.post('lista-lotes/exportar/', queryConfig, options).then(function (response) {
        this.downloading = false;
        const excelFile = new File([response.data], 'listado_lotes.xlsx');
        FileSaver.saveAs(excelFile, excelFile.name);
      }, function (reason) {
        this.downloading = false;
        console.log(reason);
        EventBus.$emit('show-error-alert', 'Error al exportar a csv');
      }.bind(this));
    },
    closeLot: function () {
      this.$http.post('lotes/' + this.selectedLot.id + '/cerrarlote/').then(function () {
        this.refreshTable();
        EventBus.$emit('show-success-alert', 'Lote cerrado correctamente');
      }, function (reason) {
        console.log(reason);
        EventBus.$emit('show-error-alert', 'Error al cerrar el lote');
      });
    },
    closeLots: function () {
      this.$http.put('lista-lotes/cerrar-lotes/').then(function () {
        this.refreshTable();
        EventBus.$emit('show-success-alert', 'Todos los lotes cerrados correctamente');
      }, function (reason) {
        console.log(reason);
        EventBus.$emit('show-error-alert', 'Error al cerrar los lotes');
      });
    }
  }

};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/cierre-lotes-management/cierre-lotes-list/CierreLotesList.vue